import { formatDate } from "@/shared/formats";
import { Filter, FilterData } from "./filter";
import dayjs from "dayjs";

export interface DateRangeFilterProps {
    type: "dateRange",
    label: string,

    fromName: string,
    fromLabel?: string,
    fromInitialValue?: string,

    toName: string,
    toLabel?: string,
    toInitialValue?: string,

    min?: string,
    max?: string
}

export interface DateRangeFilterReturn {
    type: "dateRange",
    key: string,
    label: string,
    active: boolean,

    from: string,
    fromActive: boolean,
    fromName: string,
    fromLabel: string,
    fromInitialValue: string,

    to: string,
    toActive: boolean,
    toName: string,
    toLabel: string,
    toInitialValue: string,

    min?: string,
    max?: string,

    getCriteria: () => string
}

export class DateRangeFilter extends Filter {
    label: string;
    fromName: string;
    fromLabel: string;
    fromInitialValue: string;
    toName: string;
    toLabel: string;
    toInitialValue: string;
    min?: string;
    max?: string;

    constructor({
        label,
        fromName, fromLabel = "Desde", fromInitialValue = "",
        toName, toLabel = "Hasta", toInitialValue = "",
        min, max
    }: DateRangeFilterProps) {
        super();
        this.label = label;
        this.fromName = fromName;
        this.fromLabel = fromLabel;
        this.fromInitialValue = fromInitialValue;
        this.toName = toName;
        this.toLabel = toLabel;
        this.toInitialValue = toInitialValue;
        this.min = min;
        this.max = max;
    }

    public getInitialValues(result: FilterData): void {
        result[this.fromName] = this.fromInitialValue;
        result[this.toName] = this.toInitialValue;
    }
    public getFilter(filterData: FilterData): DateRangeFilterReturn {
        const from = this.getFrom(filterData);
        const to = this.getTo(filterData);
        const fromActive = from !== this.fromInitialValue;
        const toActive = to !== this.toInitialValue;

        return {
            type: "dateRange",
            key: `${this.fromName}-${this.toName}`,
            label: this.label,
            active: fromActive || toActive,

            from: from,
            fromActive: fromActive,
            fromName: this.fromName,
            fromLabel: this.fromLabel,
            fromInitialValue: this.fromInitialValue,

            to: to,
            toActive: toActive,
            toName: this.toName,
            toLabel: this.toLabel,
            toInitialValue: this.toInitialValue,

            min: this.min,
            max: this.max,

            getCriteria: () => this.getCriteria(filterData)
        }
    }

    public parse(filterData: FilterData, result: FilterData): void {
        const from = this.getFrom(filterData);
        const to = this.getTo(filterData);
        const fromActive = from !== this.fromInitialValue;
        const toActive = to !== this.toInitialValue;

        //clamp from and to values

        if (fromActive) result[this.fromName] = from;
        if (toActive) result[this.toName] = to;
    }

    public getCriteria(filterData: FilterData): string {
        const from = this.getFrom(filterData);
        const to = this.getTo(filterData);
        const fromActive = from !== this.fromInitialValue;
        const toActive = to !== this.toInitialValue;

        if (!fromActive && !toActive) return "";
        if (fromActive && toActive) return `${this.label} entre ${formatDate(from)} y ${formatDate(dayjs(to).subtract(1, "day"))}`;
        else if (fromActive) return `${this.label} después del ${formatDate(from)}`;
        else return `${this.label} antes del ${formatDate(dayjs(to).subtract(1, "day"))}`;
    }

    private getFrom(filterData: FilterData): string {
        return String(filterData[this.fromName] || this.fromInitialValue);
    }

    private getTo(filterData: FilterData): string {
        return String(filterData[this.toName] || this.toInitialValue);
    }
}